import type { CreateUserTokenResponse, UserApiToken } from '@mp-pro/shared/interfaces';
import { MPAPISlice } from './ModelParkAPI';

export const UserTokenAPI = MPAPISlice.injectEndpoints({
    endpoints: builder => ({
        getUserTokens: builder.query<UserApiToken[], void>({
            query: () => ({ url: 'user-tokens' }),
            providesTags: ['UserTokens'],
        }),

        // password: the server asks for the current password to mint a token.
        createUserToken: builder.mutation<CreateUserTokenResponse, { name: string; expiresAt?: string; password: string }>({
            query: body => ({ url: 'user-tokens', method: 'POST', body }),
            invalidatesTags: ['UserTokens'],
        }),

        revokeUserToken: builder.mutation<void, string>({
            query: id => ({ url: `user-tokens/${id}`, method: 'DELETE' }),
            invalidatesTags: ['UserTokens'],
        }),
    }),
});

export const { useGetUserTokensQuery, useCreateUserTokenMutation, useRevokeUserTokenMutation } = UserTokenAPI;
